module.exports = __webpack_public_path__ + "static/img/user2.53ee180.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/user2.jpg
// module id = 7zXz
// module chunks = 1